import React, { useEffect, useState } from 'react';
import axios from 'axios';


import { toast } from 'react-toastify';
import Constant from '../Utils/Constant';

const EditAdminForm = ({ editPopup, setEditPopup }) => {

    const [email, setEmail] = useState("");
    const [name, setName] = useState('');
    const [phone, setPhone] = useState("");
    const [newPassword, setPassword] = useState('');
    const [createdby, setCreatedby] = useState('');
    const [existModel, setExistModel] = useState(editPopup);
    const [adminname, setAdminname] = useState("");
    const [isEmailValid, setIsEmailValid] = useState(true);
    const [isPhoneValid, setIsPhoneValid] = useState(true);
    const admin = editPopup
    const [SelectedAdmin, setSelectedAdmin] = useState(admin)


    useEffect(() => {
        const storedName = localStorage.getItem("name");

        if (storedName) {
            setAdminname(storedName);
        } else {
            setAdminname("Unauthorized");
        }
    }, []);

    const handleClose = () => {
        setEditPopup(false)
    };

    // get api 




    useEffect(() => {

        setValue()
    }, [SelectedAdmin])

    const setValue = () => {
        setName(SelectedAdmin.name)
        setEmail(SelectedAdmin.email)
        setPhone(SelectedAdmin.phone)
        setPassword(SelectedAdmin.newPassword)
        setCreatedby(SelectedAdmin.createdby)
    }



    // validationss 
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
    const validatePhone = (phone) => {
        const phoneRegex = /^\d{10}$/;
        return phoneRegex.test(phone);
    };


    const handleUpdate = async (e) => {
        e.preventDefault();
        const isEmailValid = validateEmail(email);
        const isPhoneValid = validatePhone(phone);
        setIsEmailValid(isEmailValid);
        setIsPhoneValid(isPhoneValid);
        if (isEmailValid && isPhoneValid) {
            try {
                const adminData = {
                    email,
                    name,
                    phone,
                    newPassword,
                    createdby,
                };
                const response = await axios.put(`${Constant.BASE_URL}/admin/updatebyid`, adminData);
                if (response.status === 200) {

                    handleClose();
                    setEmail('');
                    setName('');
                    setPassword('');
                    setCreatedby('')
                    setPhone('');
                    toast.success("Admin updated successfully");

                    setTimeout(() => {
                        setEditPopup(false);
                    }, 3000);


                } else {
                    console.log("Update failed:", response.status);
                }
            } catch (error) {
                console.log(error);
            }
        }
    };


    return (

        <div className="popup-form">
            <div className="flex items-center justify-center w-full">
                <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md lg:py-3 xl:py-3 2xl:p-4 ">
                    <div className="lg:w-[300px] xl:w-[300px] 2xl:w-[400px] items-center justify-center">
                        <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl ">
                            Edit Admin
                        </div>
                        <hr className="mt-1 " />
                        <form onSubmit={handleUpdate}>
                            <div className="flex flex-col items-center justify-center ">
                                <div className='lg:py-5 xl:py-5 2xl:py-10 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]'>
                                    <div className="flex items-center justify-end py-3">
                                        <label
                                            htmlFor="yourInput"
                                            className="flex items-end px-3"
                                        >
                                            Name:<span className="ml-1 text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="yourInput"
                                            className="flex items-start mb-2 border-b border-gray-500 outline-none"
                                            style={{ width: '163px', textAlign: 'center' }}
                                            placeholder="Text"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="flex items-center justify-end py-3">
                                        <label
                                            htmlFor="yourInput"
                                            className="flex items-end px-3"
                                        >
                                            Phone :<span className="ml-1 text-red-500">*</span>
                                        </label>
                                        <div className="flex flex-col">
                                            <input
                                                type="tel"
                                                id="yourInput"
                                                className="flex items-start mb-2 border-b border-gray-500 outline-none"
                                                style={{ width: "163px", textAlign: "center" }}
                                                placeholder="number"
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                                required
                                            />
                                            {!isPhoneValid && (
                                                <p className="text-red-500">
                                                    Invalid phone format (10 digits)
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-end py-3">
                                        <label
                                            htmlFor="yourInput"
                                            className="flex items-end px-3"
                                        >
                                            Email :<span className="ml-1 text-red-500">*</span>
                                        </label>
                                        <div className="flex flex-col">
                                            <input
                                                type="text"
                                                id="yourInput"
                                                className="flex items-start mb-2 border-b border-gray-500 outline-none"
                                                style={{ width: "163px", textAlign: "center" }}
                                                placeholder="email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                            {!isEmailValid && (
                                                <p className="ml-1 text-red-500">
                                                    Invalid email format
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-end py-3">
                                        <label
                                            htmlFor="yourInput"
                                            className="flex items-end px-3"
                                        >
                                            Password :<span className="ml-1 text-red-500"></span>
                                        </label>
                                        <input
                                            type="text"
                                            id="yourInput"
                                            className="flex items-start mb-2 border-b border-gray-500 outline-none"
                                            style={{ width: '163px', textAlign: 'center' }}
                                            placeholder="..............."
                                            value={newPassword}
                                            onChange={(e) => setPassword(e.target.value)}

                                        />
                                    </div>

                                    <div className="flex items-center justify-end py-3">
                                        <label
                                            htmlFor="yourInput"
                                            className="flex items-end px-3"
                                        >
                                            Created By :<span className="ml-1 text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="yourInput"
                                            className="flex items-start mb-2 border-b border-gray-500 outline-none"
                                            style={{ width: '163px', textAlign: 'center' }}

                                            placeholder={existModel.createdby}
                                            value={existModel.createdby}
                                            onChange={(e) => setCreatedby(e.target.value)}
                                            required
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="button-container flex justify-center p-1 space-x-12 lg:pb-5 xl:pb-5 2xl:pb-5 
                                        lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">

                                    <button
                                        type="button"
                                        onClick={handleClose}
                                        className="flex-shrink-0 px-3 py-1 bg-white shadow-md rounded-sm"
                                        style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="submit"
                                        className="flex-shrink-0 px-3 py-1 rounded-sm"
                                        style={{
                                            background: "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                                        }}
                                    >
                                        Update
                                    </button>

                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>

    )
}

export default EditAdminForm